<script setup>
import AudienceForm from '@frontJs/components/forms/projectManagement/sma/AudienceForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { facebookAdsAudience, facebookAdsAudienceTypes, tenant } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    facebookAdsAudience: {
        type: Object,
        required: false,
    },
    facebookAdsAudienceTypes: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="facebookAdsAudience">
            Mettre à jour l'audience #{{ facebookAdsAudience.id }} - Audiences
            SMA - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer une audience - Audiences - SMA - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle v-if="facebookAdsAudience" :tenant-name="tenant.name">
        Gestion de projet - SMA - Audiences - Mettre à jour l'audience #{{
            facebookAdsAudience.id
        }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - SMA - Audiences - Créer une audience
    </PageTitle>

    <AudienceForm
        :tenant="tenant"
        :facebook-ads-audience="facebookAdsAudience"
        :facebook-ads-audience-types="facebookAdsAudienceTypes"
    />
</template>
